import React from 'react';

import { Box, Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../redux/slices/auth/authThunk';

const ErrorDialog = ({ }) => {
    const dispatch = useDispatch();

    const { forceLogout } = useSelector(state => state.auth);
    
    const handleClose = async (e) => {
        e.preventDefault();
        await dispatch(logout())
    }

    return (
        forceLogout ?
            <Dialog open={forceLogout} onClose={async (e) => await handleClose(e)}>
                <DialogTitle>
                    Sorry!
                </DialogTitle>
                <DialogContent>
                        Sorry, it seems your session has expired. Please log in again.
                </DialogContent>
                <Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: "0.5rem"}}>
                    <Button variant="raised" onClick={async (e) => await handleClose(e)}>Ok!</Button>
                </Box>
            </Dialog>
            :
            <Outlet />
    )
}

export default ErrorDialog;